import { useTranslation } from '@refinedev/core';
import { ClaimTableSelectFilter } from './ClaimTableSelectFilter';
import type { ClaimTableSelectFilterProps } from './ClaimTableSelectFilter';

export type ClaimStatusFilterProps = Pick<
  ClaimTableSelectFilterProps,
  'data' | 'value' | 'onChange'
>;

export const ClaimStatusFilter = (props: ClaimStatusFilterProps) => {
  const { translate } = useTranslation();
  return (
    <ClaimTableSelectFilter
      {...props}
      placeholder={translate(
        'pages:claims.statusDropdown.placeholder',
        'Filter by Status'
      )}
      disabledOptionTitle={translate(
        'pages:claims.statusDropdown.outsideBand',
        'Switch bands to filter by this status.'
      )}
    />
  );
};
